export type GoogleMapsGlobal = {
  maps: {
    Map: new (el: HTMLElement, options: Record<string, unknown>) => {
      panTo(pos: { lat: number; lng: number }): void;
      setZoom(zoom: number): void;
    };
    Geocoder: new () => {
      geocode(
        request: { location: { lat: number; lng: number } },
        callback: (
          results: Array<{ formatted_address: string }> | null,
          status: string,
        ) => void,
      ): void;
    };
    marker: {
      AdvancedMarkerElement: new (options: Record<string, unknown>) => {
        position:
          | { lat: number; lng: number }
          | { lat(): number; lng(): number }
          | null;
        addListener(event: string, callback: () => void): void;
      };
    };
    places: {
      Autocomplete: new (
        input: HTMLInputElement,
        options: Record<string, unknown>,
      ) => {
        addListener(event: string, callback: () => void): void;
        getPlace(): {
          formatted_address?: string;
          geometry?: { location?: { lat(): number; lng(): number } };
        };
      };
    };
  };
};

let loadPromise: Promise<GoogleMapsGlobal> | null = null;

export function loadGoogleMaps(): Promise<GoogleMapsGlobal> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_BROWSER_KEY;
    if (!apiKey) {
      reject(new Error("VITE_GOOGLE_MAPS_BROWSER_KEY não configurada"));
      return;
    }
    if (window.google?.maps) {
      resolve(window.google);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.onload = () => {
      if (window.google?.maps) resolve(window.google);
      else reject(new Error("Google Maps não inicializou"));
    };
    script.onerror = () => reject(new Error("Falha ao carregar Google Maps"));
    document.head.appendChild(script);
  });

  return loadPromise;
}

declare global {
  interface Window {
    google?: GoogleMapsGlobal;
  }
}
